import React from 'react';
import { Document } from '@/db/types/document';
import { Button } from '@mes-amis/galette-design-system';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

interface PendingDocumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  pendingDocument: Document | null;
  templateName: string;
  onOpenExisting: () => void;
  onCreateNew?: () => void;
}

const PendingDocumentModal: React.FC<PendingDocumentModalProps> = ({
  isOpen,
  onClose,
  pendingDocument,
  templateName,
  onOpenExisting,
  onCreateNew,
}) => {
  if (!isOpen || !pendingDocument) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
          <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10">
                <ExclamationCircleIcon className="h-6 w-6 text-yellow-600" />
              </div>
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <h3 className="text-base font-semibold leading-6 text-gray-900">
                  Pending {templateName} Found
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    You have an incomplete {templateName} for this client that was last updated on{' '}
                    {pendingDocument.updated_at
                      ? new Date(pendingDocument.updated_at).toLocaleDateString()
                      : 'an unknown date'}.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 gap-3">
            <Button variant="primary" size="sm" onClick={onOpenExisting}>
              Open Existing
            </Button>
            {onCreateNew && (
              <Button variant="tertiary" size="sm" onClick={onCreateNew}>
                Create New
              </Button>
            )}
            <Button variant="tertiary" size="sm" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingDocumentModal;
